'use client';
import React from 'react';
import AppImage from '@/components/ui/AppImage';

export default function Header() {
  return (
    <>
      {/* Gradient blur overlay at top */}
      <div className="gradient-blur">
        <div></div><div></div><div></div>
        <div></div><div></div><div></div>
      </div>

      <nav className="fixed z-50 top-0 inset-x-0 px-6 py-5 flex justify-between items-center pointer-events-none">
        {/* Logo */}
        <a
          href="https://www.thestrategydesk.com"
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-auto flex items-center px-4 py-2 rounded-full glass-panel hover:border-accent/30 transition-all duration-300"
        >
          <AppImage
            src="/assets/images/Logo_final-1772237632484.png"
            alt="The Strategy Desk logo"
            width={160}
            height={48}
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* CTA */}
        <a
          href="https://strategyshelf.mysamcart.com/checkout/mastering-swot-analysis-a-practical-guide-for-success"
          className="pointer-events-auto btn-download text-background text-sm font-semibold font-manrope px-5 py-2.5 rounded-full shadow-lg"
        >
          Get the Book — $9.99
        </a>
      </nav>
    </>
  );
}